export enum OrigemDocumentoFiscalRecebidoEnum {
  EstruturaAntiga = 1,
  EstruturaNova = 2,
}
